export default __webpack_public_path__ + "static/media/escultura.6e5fe16b.jpg";